import React, { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import queryString from 'query-string';
import logo from './images/apps4orglogo.png';
import Routers from './Components/Router';
import { CommonPageSpinner } from './Components/CommonSpinner';
import {  getConfig } from './Components/ConfigHelperFunction';
import Footer from './Components/Footer';



const App = () => {
  const [dataloaded, setDataloaded] = useState(false);
  global.$s3bucket = "wesicore";
  global.$notificationCount = 0
  global.$clearnotificationCount = 0
  global.$clearnotification = false
  
  const reload = () => {
    window.open(`https://d1y1dr9xzw7t4i.cloudfront.net/?code=${window.name}`, "_self");
  };
  
  useEffect(() => {

    setDataloaded(false);
    const fetchData = async () => {
      getString();

      if (global.$code === undefined && window.name != '') {
        reload()
      }

      const result = await getConfig();
      setDataloaded(result);
    };

    fetchData();
    
  }, []);

 

  

  const getString = () => {

    const url = queryString.parse(window.location.search);

    global.$loginstatus = "false";

    global.$code = url.code;                // Uncomment for general build
    global.$homepage = url.homepage;
    global.$utype = url.utype;
    //global.$code = 'aicup2022';           // Uncomment for customer builds
    //global.$code = 'aicup2021';           // Uncomment for customer builds
    //global.$code = 'snawa2021conf';   // Uncomment for customer builds
    //global.$code = 'travcon2021';         // Uncomment for customer builds
    //global.$code = 'travcon2022';         // Uncomment for customer builds
    //global.$code = 'travcon2022exhibitor'; // Uncomment for customer builds
    //global.$code = 'travcon2023exhibitor'; // Uncomment for customer builds
    //global.$code = 'travcon2024exhibitor'; // Uncomment for customer builds
    //global.$code = 'travcon2023';         // Uncomment for customer builds
    //global.$code = 'sfhha2021summit';     // Uncomment for customer builds
    //global.$code = 'caiforum2021';        // Uncomment for customer builds
    //global.$code = 'isfacon2020';         // Uncomment for customer builds
    //global.$code = 'sfhhaconf';           // Uncomment for customer builds
    //global.$code = 'tb2021reversetradeshow';         // Uncomment for customer builds
    //global.$code = 'tb2021tradeshow';           // Uncomment for customer builds
    //global.$code = 'learnpat2021';           // Uncomment for customer builds
    //global.$code = 'virtualsummit';

    if (global.$code != undefined) {
      window.name = global.$code
    }

    if (window.name == "undefined") {
      window.name = url.code;
    }

    if (window.name == "") {
      window.name = url.code;
    }

    if (window.name == " ") {
      window.name = url.code;
    }

    //Mode
    global.$mode = url.mode;
    if (global.$mode == null) {
      global.$mode = "live";
    }

    console.log(window.name);
  }

  

  if (dataloaded) {
    return (
      <div>
        {
          global.$code != null && (global.$code === "learnpat2021" || global.$code === "devtest3" || global.$code === "njrhc2023") ?
            (
              <div id="google_translate_element"></div>
            )
            :
            ('')
        }
        {
          global.$code ?
            (
              <div>
                
                <Routers code={global.$code} s3={global.$s3} bucket={global.$s3bucket} />
                {/* <MenuBar code={global.$code} s3={global.$s3} bucket={global.$s3bucket} /> */}
                <Footer />
              </div>
            )
            :
            (
              <div style={{ textAlign: "center", marginTop: "60px" }}>
                {/*<img src={logo} />*/}
                <br />
                <br />
                
                <a href={`https://d1y1dr9xzw7t4i.cloudfront.net/?code=${window.name}`} onClick={reload} className="refresh-site" target="_self"></a>
                <br />
                <br />
                <img className="banner" src={""} height="600px" width="100%" /><br />
              </div>
            )
        }
      </div>
    );
  } else {
    return (
      <div className='app_'>
        <CommonPageSpinner />
      </div>
    );
  }
};

export default App;
